import Component from './src/index.vue';
import { FormValidateOptions } from './src/type';

export default Component;
export { FormValidateOptions };
